<template>
	<b-modal ref="modal" title="Delete your account" :busy="loading>0">
		<b-form @submit.stop.prevent="deleteAccount()" id="deleteAccountForm">
			<b-form-group label="Your password">
				<b-form-input type="password" v-model="password" placeholder="Current password" required></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ ok, cancel }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="danger" type="submit" form="deleteAccountForm" class="mr-2">
						Delete
					</b-button>
					<b-button size="sm" @click="cancel()">
						Cancel
					</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	data: () => ({
		password: '',
		loading: 0,
		error: null,
	}),
	methods: {
		show() {
			this.$refs.modal.show();
		},
		async deleteAccount() {
			this.loading++;
			try {
				await this.$api.delete('user', { password: this.password });
				this.$auth.load(null);
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
